import { V3toVector3, Vector3toV3 } from "@project-rouge/rg-three";
function getObjsDir(startObj, endObj) {
  const start = V3toVector3(startObj.pos);
  const end = V3toVector3(endObj.pos);
  const direction3d = end.sub(start).normalize();
  return Vector3toV3(direction3d);
}
export {
  getObjsDir
};
//# sourceMappingURL=index155.js.map
